export const API_URL = {
  CHAPTER_URL: "https://api.tolkien.dulaj.dev/chapters",
  CHARACTER_URL: "https://api.tolkien.dulaj.dev/characters",
  LOCATION_URL: "https://api.tolkien.dulaj.dev/locations",
  IMAGE_URL:
    "https://portfolio-k3s-uploads.s3.ap-southeast-1.amazonaws.com/Characters/",
  IMAGE_LOCATION_URL:
    "https://portfolio-k3s-uploads.s3.ap-southeast-1.amazonaws.com/Locations/",
};
